import React, { useState, useEffect, useRef } from "react";
import { getListaCompensacoes } from "../../service/CertidaoCompensacao";
import CardSeplag from "../../components/CardSeplag";
import TableSeplag from "../../components/TableSeplag";
import CertidaoCompensacaoForm from "./certidaoCompensacaoForm";
import { Entidade } from "../../service/CertidaoCompensacao";
import { Toast } from "primereact/toast";
import { useParams, useHistory } from "react-router-dom";
import { buscarPorCodigo } from "../../service/certidao";

import "./style.css";

const CertidaoCompensacao = () => {
  const [listCompensacao, setListCompensacao] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(Entidade);
  const [certidao, setCertidao] = useState(null);

  const toast = useRef(null);

  const { idenCertidao } = useParams();
  const history = useHistory();

  // const certidao = location.state.certidao;
  const isAutenticada = certidao && certidao.flagAutenticacao === "S";
  const isAtiva = certidao && (certidao.flagSituacao === "ATIVA" || certidao.flagSituacao === "EMCOMPENSACAO" || certidao.flagSituacao === "EMQUITACAO");

  useEffect(() => {
    buscarPorCodigo(idenCertidao).then((res) => {
      setCertidao(res);
    });

    getListaCompensacoes(idenCertidao).then((res) => {
      let lista = res.data.content.map((item) => {
        return {
          ...item,
          valorEvento: item.listaEventoCertFinanceiro.reduce((pv, cV) => pv + cV.valrEventoExecutado, 0),
          id: item.idenEventoCertidao,
        };
      });
      setListCompensacao(lista);
    });
  }, [idenCertidao]);

  const handleAdicionar = () => {
    let newForm = { ...Entidade, certidao };
    setForm(newForm);
    setShowForm(true);
  };

  // const handleEditarDado = ({ ...dados }) => {
  //   // let dataEventoCertidao = dados.dataEventoCertidao.split("/")
  //   // let data = new Date(dataEventoCertidao[2], dataEventoCertidao[1] - 1, dataEventoCertidao[0])

  //   // dados.dataEventoCertidao = data.toJSON()
  //   dados.tipoEventoCertidao.siglTipoEventoCertidao = listaTipoEventoCertidao.find(element => element.code === dados.tipoEventoCertidao.siglTipoEventoCertidao)

  //   setForm(dados)
  //   setShowForm(true)
  // }

  // const handleExcluirDado = () => {
  //   let newForm = { ...Entidade, certidao }
  //   setForm(newForm)
  // }

  const handleSalvar = async (res) => {
    window.$toast.current.show({ severity: "success", summary: "Sucesso", detail: "Ação efetuada com sucesso!" });

    buscarPorCodigo(idenCertidao).then((res) => {
      setCertidao(res);
    });

    getListaCompensacoes(idenCertidao).then((res) => {
      let lista = res.data.content.map((item) => {
        return {
          ...item,
          valorEvento: item.listaEventoCertFinanceiro.reduce((pv, cV) => pv + cV.valrEventoExecutado, 0),
          id: item.idenEventoCertidao,
        };
      });
      setListCompensacao(lista);
    });
    setShowForm(false);
  };

  const handleVoltar = () => {
    history.goBack();
  };

  function legenda() {
    if (!(isAutenticada && isAtiva)) {
      let text = "";

      if (!isAutenticada) {
        text += "autenticada ";
        if (!isAtiva) text += " e ativa";
      } else if (!isAtiva) text += "ativa";

      return (
        <div className="label-info-warning">
          <span className="span-info-warning">Atenção: A certidão não está {text}</span>
        </div>
      );
    }
    return null;
  }

  if (!certidao) {
    return <></>;
  }

  const rowExpansionTemplate = (data) => {
    return (
      <div className="orders-subtable">
        <TableSeplag
          dados={data.listaEventoCertFinanceiro}
          camposTabela={[
            { nome: "valrEventoAnt", titulo: "Vlr. Anterior" },
            { nome: "valrEventoExecutado", titulo: "Vlr. Executado" },
            { nome: "valrEventoPos", titulo: "Vlr. Pós" },
          ]}
          hasCabecalhoDinamic
          semPaginacao
        />
      </div>
    );
  };

  const onRowExpand = (event) => {
  };

  return (
    <>
      <Toast ref={toast} />
      <CardSeplag title={`Compensação da Certidão: ${certidao.numrCertidao}`} handleVoltar={handleVoltar} legenda={legenda}>
        <TableSeplag
          dados={listCompensacao}
          camposTabela={[
            { nome: "dataEventoCertidao", titulo: "Data Evento" },
            { nome: "tipoEventoCertidao.descTipoEventoCertidao", titulo: "Tipo Evento" },
            { nome: "valorEvento", titulo: "Valor do Evento" },
            { nome: "amparoLegal.descAmparoLegal", titulo: "Ato administrativo" },
          ]}
          hasEventoAcao={isAutenticada && isAtiva}
          onAdicionarDado={isAutenticada && isAtiva ? handleAdicionar : null}
          // onEditarDado={isAutenticada && isAtiva ? handleEditarDado : null}
          // onExcluirDado={handleExcluirDado}
          rowExpansionTemplate={rowExpansionTemplate}
          expander={true}
          onRowExpand={onRowExpand}
        />
      </CardSeplag>
      {showForm && <CertidaoCompensacaoForm dataForm={form} showForm={showForm} onClose={() => setShowForm(false)} handleSalvar={handleSalvar} idenCertidao={idenCertidao} />}
    </>
  );
};

export default CertidaoCompensacao;
